function instanceVideo() {
  function init() {
    jQuery(window).on('load', loadVideos);
    jQuery(window).on('resize', videoIframe);
  }
  function loadVideos() {
    const videos = jQuery('.block-background-video__video');
    for (const iterator of videos) {
      const vi = jQuery(iterator);
      const url = vi.data('source');
      vi.attr('src', url);
    }
    videoIframe();
  }
  function videoIframe() {
    const videos = jQuery('.wp-block-embed-youtube iframe');
    for (const vi of videos) {
      const video = jQuery(vi);
      const parent = video.parent();
      const width = parent.width();
      const height = .55*width;
      video.css({
        width: '100%',
        height
      });

    }
  }
  init();
}

instanceVideo();
